import { render, staticRenderFns } from "./UfcScoreModal.vue?vue&type=template&id=07f630c4&scoped=true&"
import script from "./UfcScoreModal.vue?vue&type=script&lang=js&"
export * from "./UfcScoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f630c4",
  null
  
)

export default component.exports